var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsersGroup = function SvgUsersGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "UsersGroup_svg__mask0_4350_118432",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 1H1V15H15V1ZM8 4.33333C6.8954 4.33333 5.99999 5.22877 5.99999 6.33333V7C5.99999 8.1046 6.8954 9 8 9C9.10453 9 10 8.1046 10 7V6.33333C10 5.22877 9.10453 4.33333 8 4.33333ZM7.99993 13.6667C9.69973 13.6667 11.2138 12.8715 12.1904 11.6328C11.5621 10.8168 10.5878 10.3333 9.54947 10.3333H6.45067C5.41225 10.3333 4.43783 10.8169 3.80957 11.633C4.78621 12.8715 6.30021 13.6667 7.99993 13.6667Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#UsersGroup_svg__mask0_4350_118432)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99992 14.4998C11.4057 14.4998 14.1666 11.7389 14.1666 8.33317C14.1666 4.92742 11.4057 2.1665 7.99992 2.1665C4.59417 2.1665 1.83325 4.92742 1.83325 8.33317C1.83325 11.7389 4.59417 14.4998 7.99992 14.4998Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
};
export default SvgUsersGroup;